export default "# Game Master Tools\n\n::demo{name=audio}"